const path = "/rh/instrumento-questionario";

const InstrumentoQuestionarioRoutes = {
  main: path,
  questionarios: (ano, id_instrumento) => `${path}/questionarios/${ano}/${id_instrumento}`,
};

export default InstrumentoQuestionarioRoutes;
